import React, { Component } from 'react';


class GrFooter extends Component {
    render() {
        let tncUrl,ppUrl,contactUrl,faqUrl="";
        let url=window.location.host;
        if(url.indexOf('checkastronow')>=0){
            tncUrl="http://n.checkastronow.com/gr/tnc-checkastronow?offer=1&_next=general_conditions.html";
            ppUrl="http://n.checkastronow.com/gr/tnc-checkastronow?offer=1&_next=privacy_policy.html";
            contactUrl="http://n.checkastronow.com/gr/tnc-checkastronow?offer=1&_next=contact.html"
        }else if(url.indexOf('checkastro')>=0){
            tncUrl="http://n.checkastro.cc/gr/tnc-checkastro?offer=1&_next=general_conditions.html";
            ppUrl="http://n.checkastro.cc/gr/tnc-checkastro?offer=1&_next=privacy_policy.html ";
            contactUrl="http://n.checkastro.cc/gr/tnc-checkastro?offer=1&_next=contact.html";
            faqUrl="http://n.checkastro.cc/gr/tnc-checkastro?offer=1&_next=faq.html";
        }
        return (
            <div>
                <div className={ faqUrl.indexOf('http')>=0 ? "PC-footer":''}>
                    <a href={tncUrl} target="_blank"><span> Όροι και Προϋποθέσεις</span></a> &nbsp; | &nbsp;
                    <a href={ppUrl} target="_blank"><span>Πολιτική Απορρήτου</span></a> &nbsp; | &nbsp;
                    <a href={contactUrl} target="_blank"><span>Επικοινωνία</span></a> 
                    {faqUrl.indexOf('http') >= 0 ? <span>&nbsp; | &nbsp;</span> : ''}
                    {faqUrl.indexOf('http') >= 0 ? <a href={faqUrl} target="_blank"><span>Συχνές Ερωτήσεις</span></a> : ""}
                </div>
               { faqUrl.indexOf('http')>=0 && <div className="mobile-footer">
                    <a href={tncUrl} target="_blank"><span> Όροι και Προϋποθέσεις</span></a>&nbsp; | &nbsp;
                        <a href={ppUrl} target="_blank"><span>Πολιτική Απορρήτου</span></a>&nbsp; | &nbsp;<br />
                    <a href={contactUrl} target="_blank"><span>Επικοινωνία</span></a>
                    {faqUrl.indexOf('http') >= 0 ? <span>&nbsp; | &nbsp;</span> : ''}
                    {faqUrl.indexOf('http') >= 0 ? <a href={faqUrl} target="_blank"><span>Συχνές Ερωτήσεις</span></a> : ""}
                </div>}
            </div>
        );
    }
}

export default GrFooter;


// WEBPACK FOOTER //
// ./src/checkastronow/components/footer/grfooter.js